exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg.logo-company {\n    max-width: 150px;\n}\n.conteneurLead .v-window {\n  height: calc(100% - 72px);\n}\n.conteneurLead .v-tabs__item--active {\n  background: #edf4fc;\n}\n#selectMotifLead .v-menu {\n  position: static ! important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/watcheezy/WzEditeurLead.vue
// module id = Q2wR
// module chunks = 1